module.exports = __webpack_public_path__ + "static/media/play-it-cool-fool.732a6534.txt";